// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'home-alt-solid';

export const Component = () => (
  <path d='M24.377 11.92 12.595 1.144A.434.434 0 0 0 12.26 1a.434.434 0 0 0-.335.144L.144 11.92a.434.434 0 0 0-.144.335c0 .335.144.526.479.526a.43.43 0 0 0 .335-.144l2.107-1.963v11.399c0 .43.144.766.431 1.054.288.287.623.43 1.054.43h7.376v-7.854c0-.239.096-.479.288-.67a.946.946 0 0 1 .67-.288h3.927c.24 0 .48.096.719.288a.946.946 0 0 1 .287.67v7.855h2.443c.43 0 .766-.144 1.054-.431a1.41 1.41 0 0 0 .43-1.054V10.674l2.108 1.963a.434.434 0 0 0 .335.144c.335 0 .479-.191.479-.526a.434.434 0 0 0-.144-.335h-.001Zm-14.56 3.783v1.963c0 .24-.096.48-.287.67a.863.863 0 0 1-.72.336H6.849a.837.837 0 0 1-.67-.335.946.946 0 0 1-.288-.67v-1.964c0-.239.096-.479.287-.67a.946.946 0 0 1 .67-.288h1.964c.287 0 .527.096.719.288a.943.943 0 0 1 .287.67Z' />
);

export const viewBox = '0 0 25 25';
